import Hero from "../components/HelpandSupport/HeroSection";

import CTA from "../components/HelpandSupport/CTA";
import FAQSection from "../components/HelpandSupport/FAQSection";
import QuickActions from "../components/HelpandSupport/QuickActions";
import ContactSection from "../components/HelpandSupport/ContactSection";
import TrustSection from "../components/HelpandSupport/TrustSection";

function HelpandSupport() {
  return (
    <>
      
      <Hero />
      <QuickActions />
      <FAQSection />
      <ContactSection />
      <TrustSection />
      <CTA />
    </>
  );
}

export default HelpandSupport;